import { useQuery } from "@tanstack/react-query";
import { PAGINATION } from "@/shared/config/constants";
import { userApi } from "../api/user.api";
import { userQueryKeys } from "./userQueryKeys";

/** Active users (page 1, large limit) for impersonation modal. */
export function useUsersImpersonationListQuery(options?: { enabled?: boolean }) {
  const limit = PAGINATION.MAX_PAGE_SIZE;
  return useQuery({
    queryKey: userQueryKeys.impersonationList(limit),
    queryFn: () => userApi.getUsers({ page: 1, limit, isActive: true }),
    enabled: options?.enabled ?? true,
  });
}
